import { __assign } from "tslib";
import * as React from 'react';
import { SnackbarProvider as BaseSnackbarProvider, } from 'notistack';
import { useTheme, useMediaQuery } from '../styles';
import { useStyles } from './SnackbarProvider.styles';
/**
 * Bb customized SnackbarProvider from the 3rd-party library that allows for stackable snackbars.
 * https://iamhosseindhv.com/notistack
 */
export var SnackbarProvider = React.forwardRef(function (props, ref) {
    var theme = useTheme();
    var isLargeBreakpoint = useMediaQuery(theme.breakpoints.up('md'));
    var snackbarContentRoot = useStyles(props).snackbarContentRoot;
    return (React.createElement(BaseSnackbarProvider, __assign({ maxSnack: 1, anchorOrigin: {
            vertical: isLargeBreakpoint ? 'top' : 'bottom',
            horizontal: 'center',
        }, ref: ref, dense: !isLargeBreakpoint, hideIconVariant: true, ContentProps: {
            className: snackbarContentRoot,
            role: null,
            'aria-describedby': null,
        } }, props)));
});
export default SnackbarProvider;
//# sourceMappingURL=SnackbarProvider.js.map